import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { clientConfig } from '@/api/axios/config';
import type { FanguardApiContractsConfigModel } from 'src/api/generated';

export const CONFIG_URI = 'config';

export interface ConfigAuth {
  client: string;
  clientId: string;
  domain: string;
  platform: string;
}

export const configQueries = createQueryKeys(CONFIG_URI, {
  all: null,
  config: () => ({
    queryKey: ['config'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsConfigModel>({ uri: CONFIG_URI });
      return response.data;
    },
  }),
  auth: (subdomain: string) => ({
    queryKey: [subdomain],
    queryFn: async () => {
      const response = await get<ConfigAuth>({ uri: `${CONFIG_URI}/auth/${subdomain}` });
      clientConfig.setPlatform(response.data.platform);
      return response.data;
    },
  }),
});
